module.exports = __webpack_public_path__ + "img/products.a399a599.svg";